export default __webpack_public_path__ + "static/media/exhibitions1.504a2ed1.png";